import {Button, Modal} from '@mui/material'
import React, {useState, useCallback} from 'react'
import Cropper from 'react-easy-crop'
import {getOrientation} from 'get-orientation/browser'
import {getCroppedImg, getRotatedImage} from './canvasUtils'
import axios from 'axios'
import {useEffect} from 'react'
import imageInput from "../../assets/image/addImage.jpeg";
import {API_BASE_URL} from '../../configs/variable.config'
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const ORIENTATION_TO_ANGLE = {
  '3': 180,
  '6': 90,
  '8': -90,
}

const CropSingleImage = (props) => {
  const [imageSrc, setImageSrc] = useState(null)
  const [crop, setCrop] = useState({x: 0, y: 0})
  const [rotation, setRotation] = useState(0)
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("")
  const [name, setName] = useState("")
  const [progress, setprogress] = useState(0);
  const [progressDisplay, setprogressDisplay] = useState(false);
  const [image, setImage] = useState(imageInput);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }, [])

  useEffect(() => {
    const imagId = props.inputData[props.item.key]
    if (props.pageType === "edit" && imagId !== null && imagId.length > 0) {
      axios(`${props.item.get}${imagId}`, {
        responseType: 'blob'
      }).then((res) => {
        var reader = new window.FileReader();
        reader.readAsDataURL(res.data);
        reader.onload = function () {
          setImage(reader.result)
        }
        if (props.HasManyInputData) {
          props.HasManyInputData(props.index, props.HasManyKey, imagId);
        } else {
          let object = props.inputData;
          object[props.keyValue] = imagId;
          props.setInputData(object);
        }
      })
    }
  }, [props.pageType])

  useEffect(()=>{
    console.log(progress);
  },[progress])

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
          imageSrc,
          croppedAreaPixels,
          rotation,
          type
      )
      file(croppedImage.blob)
      setImage(croppedImage.base64);
    } catch (e) {
      console.error(e)
    }
  }, [imageSrc, croppedAreaPixels, rotation])

  const onFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setprogress(0)
      const file = e.target.files[0]
      let imageDataUrl = await readFile(file)
      setType(e.target.files[0].type)
      setName(e.target.files[0].name)
      try {
        const orientation = await getOrientation(file)
        const rotation = ORIENTATION_TO_ANGLE[orientation]
        if (rotation) {
          imageDataUrl = await getRotatedImage(imageDataUrl, rotation)
        }
      } catch (e) {
        console.warn('failed to detect the orientation')
      }
      setImageSrc(imageDataUrl)
      handleOpen()
    }
  }


  function file(url) {
    setprogressDisplay(true)
    fetch(url)
        .then(res => res.blob())
        .then(blob => {
          const file = new File([blob], name, {type: `${type}`})
          const formData = new FormData();
          formData.append("image", file);
          formData.append("type", props.imageType);
          axios.post(props.item.store, formData,{
            onUploadProgress: (progressEvent) => {
              const percentage = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
              );
              setprogress(percentage);
            }
          }, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          },)
              .then((res) => {
                if (props.HasManyInputData) {
                  props.HasManyInputData(props.index, props.HasManyKey, res.data.data.id);
                } else {
                  let object = props.inputData;
                  object[props.keyValue] = res.data.data.id;
                  props.setInputData(object);
                }
                setprogressDisplay(false)
              }).catch(e => console.log(e))
        })
  }

  function minus(params) {
    if (zoom >= 1.5) {
      setZoom(zoom - 0.5)
    } else if (zoom > 1 && zoom < 1.5) {
      setZoom(1)
    }
  }

  function plus(params) {
    if (zoom <= 2.5) {
      setZoom(zoom + 0.5)
    } else if (zoom < 3 && zoom > 2.5) {
      setZoom(3)
    }
  }

  return (
      <div>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className='w-[80%] 450:w-[60%] 560:w-[50%] m-auto h-[300px] md:h-[350px] md:w-[40%] lg:w-[35%] xl:w-[30%] xl:h-[400px] 1440:w-[30%] 1440:h-[500px] bg-white '>

          <div>
            <div className=" ">
              <Cropper
                  image={imageSrc}
                  crop={crop}
                  rotation={rotation}
                  zoom={zoom}
                  aspect={props.item.width && props.item.height ? Number(props.item.width) / Number(props.item.height) : 1/1}
                  onCropChange={setCrop}
                  onRotationChange={setRotation}
                  onCropComplete={onCropComplete}
                  onZoomChange={setZoom}
              />
            </div>
            <div className={"absolute bottom-[-100px] w-full bg-white items-center px-2 pb-2 rounded-b-[10px]"}>
              <div className="flex p-2 gap-2 items-center justify-around">
                <div className=" flex justify-between items-center my-2 h-[30px]">
                  <button className='w-[100px] h-[40px] border rounded-r-[20px]' onClick={minus}><i
                      className='fa fa-search-minus'></i></button>
                  {/* <span>{zoom}</span> */}
                  <button className='w-[100px] h-[40px] border rounded-l-[20px]' onClick={plus}><i
                      className='fa fa-search-plus'></i></button>
                </div>
              </div>
              <div className='px-[10%]'>
                <Button
                    onClick={() => {
                      showCroppedImage();
                      handleClose()
                    }}
                    variant="contained"
                    color="primary"
                >
                <span className='my-[5px]'>
                  ثبت
                </span>
                </Button>
              </div>
            </div>
          </div>
        </Modal>

        <div className="relative">
          <img
              src={image}
              className="w-[150px] rounded-md border-dashed border-2 border-[#5ba9aa] p-1 "
              alt=""
          />
          {progressDisplay&&<div className={`absolute z-[10] rounded-md w-[142px] p-5 m-1 top-0 right-0 bg-[#0000005b]`}>
            <CircularProgressbar value={progress} text={`${progress}%`} />
          </div>}
          <input
              className="opacity-0 absolute top-0 w-[150px] h-[150px] cursor-pointer"
              type="file"
              onChange={onFileChange}
              accept="image/*"
              disabled={props.item.disabled}
          />
        </div>
        <div className="mt-2 text-[.8rem] text-edit_input_validation">
          {props.error}
        </div>
      </div>
  )
}

function readFile(file) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => resolve(reader.result), false)
    reader.readAsDataURL(file)
  })
}

const StyledDemo = CropSingleImage
// withStyles(styles)
export default StyledDemo;
